export default {"src":"/_next/static/media/alt-logo.c10b2fc8.svg","height":11,"width":81,"blurWidth":0,"blurHeight":0};